/* eslint-disable */
// import {Video} from '../../stores/program/model/Program';
import HomePageEvents from './HomePageEvents';
import {RecommendVideo, userVideo, verticalList} from './model/HomePage';

// -----------------------------------------------------------------------------------
// おすすめビデオ
// 取得
export const GetRecVideoList = () => ({
    type: HomePageEvents.GetRecVideoListStarted
} as const);
export const GetRecVideoListComplete = (videos: RecommendVideo[]) => ({
    type: HomePageEvents.GetRecVideoListComplete,
    videos
} as const);
// TODO
export const GetEditRecVideoList = () => ({
    type: HomePageEvents.GetEditRecVideoListStarted
} as const);
export const GetEditRecVideoListComplete = (videos: RecommendVideo[]) => ({
    type: HomePageEvents.GetEditRecVideoListComplete,
    videos
} as const);
export const ResetRecVideos = () => ({
    type: HomePageEvents.ResetRecVideos,
} as const);
// 編集
export const UpdateRecVideos = ( videos: string[]) => ({
    type: HomePageEvents.UpdateRecVideosStarted,
    videos
} as const);
export const UpdateRecVideosComplete = (recommendVideoList: RecommendVideo[]) => ({
    type: HomePageEvents.UpdateRecVideosComplete,
    recommendVideoList
} as const);
export const UpdateRecVideosFailed = () => ({
    type: HomePageEvents.UpdateRecVideosFailed
} as const);
// 追加
export const AddVideoToRec = (videoId: string) => ({
    type: HomePageEvents.AddVideoToRecStarted,
    videoId
} as const);
export const AddVideoToRecComplete = (recommendVideoList: RecommendVideo[]) => ({
    type: HomePageEvents.AddVideoToRecComplete,
    recommendVideoList
} as const);

// -----------------------------------------------------------------------------------
// おすすめプログラム
// 取得
export const GetRecommendProgramList = (userId: string) => ({
    type: HomePageEvents.GetRecommendProgramListStarted,
    userId
} as const);
export const GetRecommendProgramListComplete = (recommendProgramList: verticalList[]) => ({
    type: HomePageEvents.GetRecommendProgramListComplete,
    recommendProgramList
} as const);
// 編集
export const UpdateRecPrograms = ( programs: string[], userId: string) => ({
    type: HomePageEvents.UpdateRecProgramsStarted,
    programs, userId
} as const);
export const UpdateRecProgramsComplete = (recommendProgramList: verticalList[]) => ({
    type: HomePageEvents.UpdateRecProgramsComplete,
    recommendProgramList
} as const);
export const UpdateRecProgramsFailed = () => ({
    type: HomePageEvents.UpdateRecProgramsFailed
} as const);
// 追加
export const addRecProgram = (id: number | string, userId: string) => ({
    type: HomePageEvents.addRecProgramStarted,
    id,userId
} as const);
export const addRecProgramComplete = (recommendProgramList: verticalList[]) => ({
    type: HomePageEvents.addRecProgramComplete,
    recommendProgramList
} as const);
// 削除
export const delRecProgram = (id: number | string, userId: string) => ({
    type: HomePageEvents.delRecProgramStarted,
    id,userId
} as const);
export const delRecProgramComplete = (recommendProgramList: verticalList[]) => ({
    type: HomePageEvents.delRecProgramComplete,
    recommendProgramList
} as const);

// -----------------------------------------------------------------------------------
// おすすめプロフェショナル
// 取得
export const GetRecommendProfessionalList = () => ({
    type: HomePageEvents.GetRecommendProfessionalListStarted,
} as const);
export const GetRecommendProfessionalListComplete = (recommendProfessionalList: verticalList[]) => ({
    type: HomePageEvents.GetRecommendProfessionalListComplete,
    recommendProfessionalList
} as const);
// 編集
export const UpdateRecProfessionals = ( professionals: string[]) => ({
    type: HomePageEvents.UpdateRecProfessionalsStarted,
    professionals
} as const);
export const UpdateRecProfessionalsComplete = (recommendProfessionalList: verticalList[]) => ({
    type: HomePageEvents.UpdateRecProfessionalsComplete,
    recommendProfessionalList
} as const);
export const UpdateRecProfessionalsFailed = () => ({
    type: HomePageEvents.UpdateRecProfessionalsFailed
} as const);
// 追加
export const addRecProfessional = (id: number) => ({
    type: HomePageEvents.addRecProfessionalStarted,
    id
} as const);
export const addRecProfessionalComplete = (recommendProfessionalList: verticalList[]) => ({
    type: HomePageEvents.addRecProfessionalComplete,
    recommendProfessionalList
} as const);
// 削除
export const removeRecProfessional = (id: number) => ({
    type: HomePageEvents.removeRecProfessionalStarted,
    id
} as const);
export const removeRecProfessionalComplete = (recommendProfessionalList: verticalList[]) => ({
    type: HomePageEvents.removeRecProfessionalComplete,
    recommendProfessionalList
} as const);

// -----------------------------------------------------------------------------------
// 新着ビデオ
// 取得
export const GetNewVideoList = (userId: string) => ({
    type: HomePageEvents.GetNewVideoListStarted,
    userId
} as const);

export const GetNewVideoListComplete = (newVideoList: verticalList[]) => ({
    type: HomePageEvents.GetNewVideoListComplete,
    newVideoList
} as const);

// -----------------------------------------------------------------------------------
// ユーザー視聴履歴
// 取得
export const GetVideoListByUser = (userId: string) => ({
    type: HomePageEvents.GetVideoListByUserStarted,
    userId
} as const);

export const GetVideoListByUserComplete = (userVideos: userVideo[]) => ({
    type: HomePageEvents.GetVideoListByUserComplete,
    userVideos
} as const);

export const ResetUserVideos = () => ({
    type: HomePageEvents.ResetUserVideos,
} as const);
